import React from 'react';
import LegalDocumentPage from '../LegalDocumentPage/LegalDocumentPage';
import {PRIVACY_POLICY_CONTENT} from '../../../configs/legal/privacyPolicy';

function PrivacyPolicyPage({onBack}) {
  return (
    <LegalDocumentPage
      pageId="PrivacyPolicyPage"
      content={PRIVACY_POLICY_CONTENT}
      onBack={onBack}
    />
  );
}

export default PrivacyPolicyPage;
